import { render } from "./PaymentSchemeLearn.vue?vue&type=template&id=0e920cba&scoped=true"
import script from "./PaymentSchemeLearn.vue?vue&type=script&lang=js"
export * from "./PaymentSchemeLearn.vue?vue&type=script&lang=js"

import "./PaymentSchemeLearn.vue?vue&type=style&index=0&id=0e920cba&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e920cba"]])

export default __exports__